import { ECases } from '@/domains/rodo/enums/Cases'
import type { IRadioButton } from '~/components/RadioButtonController/RadioButton/RadioButton.types'

export const useTopics = () => {
  const { t } = useI18n()
  const topics = ref<IRadioButton[]>([
    {
      id: 'case-0',
      label: t('rodo.cases.yourself'),
      value: ECases.OWN_CASE,
    },
    {
      id: 'case-1',
      label: t('rodo.cases.child'),
      value: ECases.CHILD_CASE,
    },
    {
      id: 'case-2',
      label: t('rodo.cases.otherPerson'),
      value: ECases.OTHER_PERSON_CASE,
    },
  ])

  return {
    topics,
  }
}
